import { render, staticRenderFns } from "./PersonaViaticoIndPage.vue?vue&type=template&id=91560652"
import script from "./PersonaViaticoIndPage.js?vue&type=script&lang=js&external"
export * from "./PersonaViaticoIndPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports